import { hydrateRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { ApolloProvider } from '@apollo/client';
import { useEffect } from 'react';

import ScrollContext from './components/ScrollContext';
import App from './components/App';
import { createClient } from './lib/graphql/client';
import { createRoutesMap } from './lib/routes';
import { configureStore } from './store';
import { initializeViewport } from './store/responsive/actions';
import { setTimeZone } from './store/intl/actions';
import { AnalyticsContextProvider } from './lib/analytics/context';
import { ExperimentationProvider } from './lib/experimentation';

const client = createClient(
  {
    // This is broken in Apollo client.
    // https://github.com/apollographql/apollo-client/pull/5839
    // ssrForceFetchDelay: 100,
    connectToDevTools: true,
  },
  { initialState: window.__APOLLO_STATE__ }
);
const { store } = configureStore(window.REDUX_STATE, {
  routesMap: createRoutesMap(window.PAGES, { graphqlClient: client }),
});

const InitAfterRender = (props) => {
  useEffect(() => {
    store.dispatch(initializeViewport({ width: window.innerWidth }));
    store.dispatch(
      setTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
    );
  }, []);
  return props.children;
};

const render = (Component) => {
  hydrateRoot(
    document.getElementById('hub'),
    <InitAfterRender>
      <ApolloProvider client={client}>
        <Provider store={store}>
          <HelmetProvider>
            <ScrollContext>
              <AnalyticsContextProvider>
                <ExperimentationProvider>
                  <Component />
                </ExperimentationProvider>
              </AnalyticsContextProvider>
            </ScrollContext>
          </HelmetProvider>
        </Provider>
      </ApolloProvider>
    </InitAfterRender>
  );
};

render(App);
